import { Injectable, Injector } from '@angular/core';
import { TCSettingsService } from '@cloud-twin-v2/cloud-twin-shared/core/tc-settings.service';
import { Observable } from 'rxjs';
import { GetCacheOpts } from '../../cache/http-cache/http-cache.client';
import { BaseService } from '../../shared/base.service';
import { DateHelperService } from '../../shared/helpers/date-helper.service';
import { Leaflet } from '../leaflet-export';
import { LayerItem } from '../models/layer-item';

@Injectable()
export class FeatureInfoService extends BaseService {
  expiration: GetCacheOpts = { expiration: 'default', reload: true };
  constructor(
    private _injector: Injector,
    private _dateHelperService: DateHelperService,
    private _tcSettingsService: TCSettingsService
  ) {
    super(_injector);
  }

  getFeatureFromLayer(latlng, layerItem: LayerItem, map): Observable<any> {
    const url = this.getFeatureInfoURL(latlng, layerItem.nativeLayer.options, map);
    return this.httpCacheClient.get(url, this.expiration);
  }

  getFeatureInfoURL(point, layerInfo, map) {
    // Construct a GetFeatureInfo request URL given a point
    const wmsURL = (layerInfo.url as string).replace('/ows', `/${layerInfo.typeNS}/wms?`);
    const size = map.getSize();
    const currentTime = map.timeDimension._availableTimes[map.timeDimension._currentTimeIndex];
    const time = this._dateHelperService.toApiFormat(new Date(currentTime));
    const params = {
      request: 'GetFeatureInfo',
      service: 'WMS',
      srs: 'EPSG:4326',
      time: time,
      version: '1.1.1',
      bbox: map.getBounds().toBBoxString(),
      height: size.y,
      width: size.x,
      layers: layerInfo.typeNSName,
      query_layers: layerInfo.typeNSName,
      info_format: 'application/json',
    };

    params[params.version === '1.3.0' ? 'i' : 'x'] = point.x;
    params[params.version === '1.3.0' ? 'j' : 'y'] = point.y;

    const url = wmsURL + Leaflet.Util.getParamString(params, wmsURL, true);

    return url;
  }

  getLayersByNamespace(namespace: string) {
    return this.httpCacheClient.get(
      `${this._tcSettingsService.geoServer.url}/rest/workspaces/${namespace}/featuretypes.json`
    );
  }

  getLayerInfo(url: string): Observable<any> {
    return this.httpCacheClient.get(url, this.avoidCache);
  }
}
